import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LoadingContext } from '../../contexts';
import DefaultSection, {HorizontalRule} from '../../components/default_section/default_section';
import DefaultInput, { HalfWrapper } from '../../components/default_input/default_input';
import WarningMessage from '../../components/warning_message/warning_message';
import { getCnpjText } from '../../utils/functions';
import './clinic_data.scss';

class ClinicData extends React.Component {
  handleKeyDown(event) {    
    if(event.keyCode === 13 && this.props.enableSave && !this.props.isLoading) {
      this.props.onSave();
    }
  }

  isHighlighted(propertyName) {
    return this.props.highlights.includes(propertyName);
  }

  render() {
    return (
      <DefaultSection
        className="clinic-data"
        title="Dados do cliente"
      >

        <div className="clinic-data__warning-container">

          <WarningMessage
            message={this.props.warningMessage}
            onClose={this.props.onCloseWarning}
            visible={this.props.showWarningMessage}
          />

        </div>

        <div className="clinic-data__input-container">

          <DefaultInput
            name="is_active"
            isHighlighted={this.isHighlighted("is_active")}
            label="Ativo:"
            type="toggle"
            isHorizontal={true}
            activeText="Sim"
            inactiveText="Não"
            handleInputChange={this.props.handleInputChange}
            value={this.props.clinic.is_active}
            horizontalAlign="right"
            disabled={this.props.isLoading}
          />

          <HalfWrapper>

            <DefaultInput
              name="name"
              isHighlighted={this.isHighlighted("name")}
              label="Nome"
              type="text"
              placeholder="Nome do cliente"
              maxLength="128"
              handleInputChange={this.props.handleInputChange}
              value={this.props.clinic.name}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

            <DefaultInput
              name="email"
              isHighlighted={this.isHighlighted("email")}
              label="E-mail"
              type="email"
              placeholder="E-mail do cliente"
              maxLength="128"
              handleInputChange={this.props.handleInputChange}
              value={this.props.clinic.email}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

          </HalfWrapper>

          <DefaultInput
            name="cnpj"
            isHighlighted={this.isHighlighted("cnpj")}
            label="CNPJ"
            type="text"
            placeholder="CNPJ do cliente"
            maxLength="18"
            handleInputChange={this.props.handleInputChange}
            value={getCnpjText(this.props.clinic.cnpj)}
            autoComplete="off"
            onKeyDown={(event) => this.handleKeyDown(event)}
            disabled={this.props.isLoading}
          />

          <DefaultInput
            name="notes"
            isHighlighted={this.isHighlighted("notes")}
            label="Notas / Observações"
            type="textarea"
            placeholder="Notas sobre o clinete"
            rows="4"
            handleInputChange={this.props.handleInputChange}
            value={this.props.clinic.notes || ''}
            disabled={this.props.isLoading}
          />

        </div>

        <HorizontalRule />

        <div className="clinic-data__buttons-container">

          <button
            className="clinic-data__save-button"
            disabled={!this.props.enableSave || this.props.isLoading}
            onClick={this.props.onSave}
          >

            Salvar

          </button>

          <Link
            className="clinic-data__cancel-button"
            to={this.props.onCancelPath}
            disabled={this.props.isLoading}
          >

            Cancelar

          </Link>

        </div>

      </DefaultSection>
    );
  }
};

const WrappedClinicData = props => {
  const {isLoading} = useContext(LoadingContext);

  return (
    <ClinicData
      isLoading={isLoading}
      {...props}
    />
  );
};

export {WrappedClinicData as ClinicData};
